<template>
<div>
  <div class="title-bar detail clearfix">
    <div class="module pull-left">
        {{ $t("user.editUser") }}
    </div>
    <div class="btn-group pull-right">
      <el-button type="primary" :plain="true" size="mini" @click="addUser('addUserForm')">{{ $t("save") }}
      </el-button>
      <el-button :plain="true" size="mini" @click="cancelOperation()">{{ $t("cancel") }}
      </el-button>
    </div>
  </div>
  <div class="data-list detail">
    <div class="detail-header">
      <span>{{$t("user.info")}}</span>
      <div class="detail-triangle"></div>
    </div>
    <div class="detail-content" v-loading="loading">
      <el-form class="detail-form" ref="addUserForm" :model="userInfo" label-width="80px" size="small" :rules="rules" status-icon>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="12" :lg="12">
            <el-form-item :label="this.$t('user.email')" prop="Email">
              <el-input v-model="userInfo.Email" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12">
            <el-form-item :label="this.$t('user.rolesPlaceholder')" prop="UserRoles">
              <el-select v-model="userInfo.UserRoles">
                <el-option v-for="role in rolesList" :key="role" :label="$t(`user.roles.${role}`)" :value="role"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="12" :lg="12">
            <el-form-item :label="this.$t('user.name')" prop="Name">
              <el-input v-model="userInfo.Name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12">
            <el-form-item :label="this.$t('user.phoneNumber')" prop="PhoneNumber">
              <el-input v-model="userInfo.PhoneNumber"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "EditUser",
  data() {
    return {
      userInfo: {},
      rolesList: [],
      loading: true,
      rules: {
        Email: [
          {
            required: true
          },
          {
            type: "email",
            message: this.$t("user.emailFormatValidation")
          }
        ],
        Name: [
          {
            required: true,
            message: this.$t("user.nameValidation")
          }
        ],
        UserRoles: [
          {
            required: true,
            message: this.$t("user.userRolesValidation")
          }
        ],
          PhoneNumber: [        
            {
          validator: (rule, value, callback) => {
          var raw= JSON.stringify(value).replace(/\"/g, "");
          if(raw==""||raw==null||raw==undefined)
          {
            callback();
          }
          var format =raw.replace(/[^0-9+]/g,'');
              
          if (raw.length!=14&&raw.length!=11||raw.length==14&&raw.charAt(0)!='+'||raw.substring(1,raw.length).includes("+")||raw.length>format.length) {
           
            callback(new Error("请输入正确的手机号码"));
          } else {
            callback();
           }
         }, trigger: 'blur'
       }
            
         ]
      }
    };
  },
  created() {
    this.loading = true;
    this.$axios.get("api/Roles").then(response => {
      this.rolesList = response.data.map(r => r.Name);
    });

    this.$axios.get(`api/users/${this.$route.params.userId}`).then(response => {
      this.userInfo = response.data;
      this.userInfo.UserRoles = this.userInfo.UserRoles[0];
      this.loading = false;
    });
  },
  methods: {
    goBack() {
      this.$router.push({ name: "UserManagement" });
    },
    addUser(addUserForm) {
      this.$refs[addUserForm].validate(valid => {
        if (valid) {
          this.$axios
            .put("api/Users", this.userInfo)
            .then(response => {
              this.$message({
                message: this.$t("user.userUpdatedSuccessfully"),
                type: "success",
                showClose: true,
                duration: 2000
              });
              this.goBack();
            })
            .catch(e => {
              let modelState = e.response && e.response.data.ModelState;
              let msg =
                (modelState && Object.values(modelState).join()) ||
                this.$t("user.operationFailure");
              this.$message({
                message: msg,
                type: "error"
              });
            });
        } else {
          this.$message({
            message: this.$t("user.operationFailure"),
            type: "error",
            showClose: true,
            duration: 2000
          });
        }
      });
    },
    cancelOperation() {
      this.goBack();
    }
  }
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/application/UserManagement/EditUser.vue